export const AccountIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="16" height="16" viewBox="0 0 13.9426 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M7.89014 9.04869H6.05243C2.7166 9.04869 0 11.7553 0 15.1011C0 15.6005 0.409488 16 0.898876 16H13.0437C13.5331 16 13.9426 15.6005 13.9426 15.1011C13.9426 11.7553 11.226 9.04869 7.89014 9.04869ZM6.05243 10.0474H7.88015C10.6367 10.0474 12.8839 12.2547 12.9338 15.0012H0.998752C1.04869 12.2547 3.29588 10.0474 6.05243 10.0474Z"
                fill="currentColor"
            />
            <path
                d="M6.97129 7.45069C4.91386 7.45069 3.24594 5.78277 3.24594 3.72534C3.24594 1.66792 4.91386 0 6.97129 0C9.02871 0 10.6966 1.66792 10.6966 3.72534C10.6966 5.78277 9.02871 7.45069 6.97129 7.45069ZM6.97129 0.998752C5.46317 0.998752 4.24469 2.22722 4.24469 3.72534C4.24469 5.22347 5.47316 6.45193 6.97129 6.45193C8.46941 6.45193 9.69788 5.22347 9.69788 3.72534C9.69788 2.22722 8.46941 0.998752 6.97129 0.998752Z"
                fill="currentColor"
            />
        </svg>
    );
};
